import { Stack, Typography } from "@mui/material";

function PriceHistoryRecordFieldGroup({ title, children }) {
  return (
    <Stack spacing={1.5}>
      <Typography
        variant="subtitle2"
        component="h3"
        sx={{
          fontWeight: 700,
          color: "text.secondary",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          fontSize: "0.75rem",
        }}
      >
        {title}
      </Typography>
      <Stack spacing={1.5} sx={{ width: "100%" }}>
        {children}
      </Stack>
    </Stack>
  );
}

export default PriceHistoryRecordFieldGroup;
